import React from "react";
import PropTypes from "prop-types";
import { checkOfflineState } from "./OfflineDetect";

const Tab = ({ title, description, onClick, isActive, downloadCount, totalCount, className=null, disabled=false }) => {
  const total = downloadCount !== undefined && totalCount !== undefined ? `\nTotal results: ${totalCount}` : "";
  const progress = downloadCount !== undefined && totalCount !== undefined && downloadCount !== totalCount
    ? `\nLoaded ${downloadCount} of ${totalCount} results` : downloadCount === totalCount ? total : "";
  const isDisabled = totalCount === 0 || disabled;
  const displayDescription = totalCount === 0 ? "No results" : description;
  return isDisabled ? (
    <span
      className={`tab tab-span-disabled disabled${className ? ' ' + className : ''}`}
      title={`${displayDescription}${progress}`}
    >
      {title}
    </span>
  ) : (
    <button
      title={`${displayDescription}${progress}`}
      onClick={checkOfflineState(onClick)}
      className={`tab${isActive ? " active" : ""}${className ? ' ' + className : ''}`}
    >
      {title}
    </button>
  );
};

Tab.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  description: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default Tab;
